import React, { Children } from 'react';
import GalleryView, { GalleryItem } from '../../components/Creative/GalleryView';
// Sample data for interior book art
const interiorArtItems: GalleryItem[] = [{
  id: '1',
  imageUrl: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Fantasy Chapter Headers',
  creator: 'Marcus Lee',
  price: 75,
  priceType: 'fixed',
  serviceType: 'Chapter Headers',
  genre: ['Fantasy', 'Adventure'],
  description: 'Set of custom chapter headers with fantasy motifs, perfect for epic fantasy novels.'
}, {
  id: '2',
  imageUrl: 'https://images.unsplash.com/photo-1618005198919-d3d4b5a92ead?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Decorative Page Borders',
  creator: 'Amelia Wright',
  price: 120,
  priceType: 'fixed',
  serviceType: 'Page Borders',
  genre: ['Historical', 'Romance'],
  description: 'Elegant decorative borders for special edition books or chapter openers.'
}, {
  id: '3',
  imageUrl: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Custom Endpapers',
  creator: 'Daniel Kim',
  price: 200,
  priceType: 'starting',
  serviceType: 'Endpapers',
  genre: ['Fantasy', 'Science Fiction'],
  description: "Unique patterned endpapers that complement your book's theme and aesthetic."
}, {
  id: '4',
  imageUrl: 'https://images.unsplash.com/photo-1618005198919-d3d4b5a92ead?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: "Children's Book Illustrations",
  creator: 'Sophia Chen',
  price: 350,
  priceType: 'commissioned',
  serviceType: 'Full Page Illustrations',
  genre: ["Children's", 'Middle Grade'],
  description: "Colorful and engaging full-page illustrations for children's books."
}, {
  id: '5',
  imageUrl: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Title Page Design',
  creator: 'Marcus Lee',
  price: 85,
  priceType: 'fixed',
  serviceType: 'Title Page',
  genre: ['Multiple'],
  description: 'Elegant and distinctive title page designs to make your book stand out.'
}, {
  id: '6',
  imageUrl: 'https://images.unsplash.com/photo-1618005198919-d3d4b5a92ead?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Map Illustrations',
  creator: 'Daniel Kim',
  price: 250,
  priceType: 'starting',
  serviceType: 'Maps',
  genre: ['Fantasy', 'Adventure'],
  description: "Detailed fantasy or historical maps for your novel's world."
}, {
  id: '7',
  imageUrl: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Foil Stamping Design',
  creator: 'Amelia Wright',
  price: 150,
  priceType: 'fixed',
  serviceType: 'Foil Design',
  genre: ['Multiple'],
  description: 'Special edition foil stamping designs for hardcover books.'
}, {
  id: '8',
  imageUrl: 'https://images.unsplash.com/photo-1618005198919-d3d4b5a92ead?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Spot Illustrations',
  creator: 'Sophia Chen',
  price: 40,
  priceType: 'starting',
  serviceType: 'Spot Illustrations',
  genre: ['Multiple'],
  description: "Small decorative illustrations to enhance your book's interior design."
}];
const InteriorArtGallery = () => {
  return <GalleryView items={interiorArtItems} title="Interior Book Art Gallery" categoryName="Interior Art" data-id="element-9308" data-mp="8fcqpds414eo" />;
};
export default InteriorArtGallery;